import { instance as axios } from './axiosInstance'
import { statusHandler } from '../utils/loginHelper'

const getPrintLaudoEndpoint = (id) => `/api/solicitacao/${id}/laudo/print`

const getHeader = (token) => (
  {
  'Authorization': `Bearer ${token}`
  }
)

export const getPrintLaudo = (token, id) => {
  const headers = getHeader(token)
  
  return axios.get(getPrintLaudoEndpoint(id), { validateStatus: statusHandler, headers })
}

export const getLaudoWhatsappPreview = (token, id) => {
  const headers = getHeader(token)
  return axios.get(`/api/solicitacao/${id}/laudo/enviar-whatsapp/preview`, {
    validateStatus: statusHandler,
    headers,
  })
}

export const sendLaudoWhatsapp = (token, id) => {
  const headers = getHeader(token)
  return axios.post(`/api/solicitacao/${id}/laudo/enviar-whatsapp`, {}, {
    validateStatus: statusHandler,
    headers,
  })
}

export const getDocumentosColetaLaudo = (token, id, params = {}) => {
  const headers = getHeader(token)
  return axios.get(`/api/solicitacao/${id}/documentos-coleta`, {
    validateStatus: statusHandler,
    headers,
    params,
  })
}

export const getDocumentosColetaPdf = (token, id, params = {}) => {
  const headers = getHeader(token)
  return axios.get(`/api/solicitacao/${id}/documentos-coleta/pdf`, {
    validateStatus: statusHandler,
    headers,
    params,
  })
}

export const downloadDocumentoColeta = (token, id, params = {}) => {
  const headers = getHeader(token)
  return axios.get(`/api/solicitacao/${id}/documentos-coleta/arquivo`, {
    validateStatus: statusHandler,
    headers,
    params,
    responseType: 'blob',
  })
}

export const uploadDocumentoColeta = (token, id, formData) => {
  const headers = getHeader(token)
  return axios.post(`/api/solicitacao/${id}/documentos-coleta`, formData, {
    validateStatus: statusHandler,
    headers,
  })
}
